<form novalidate #setupForm="ngForm" class="form">
  <div class="title-container">
    <div class="title">Performance Monitor</div>
    <div><i class="mdi mdi-close close" mat-dialog-close></i></div>
  </div>
  <div class="setup-container">
    <div class="section-container">
      <div class="section-data">
        <div class="group">
          <div class="label">SLM Period</div>
          <mat-select
            name="slmPeriod"
            class="option-list"
            #slmPeriodInput="ngModel"
            [(ngModel)]="formField.slmPeriod"
          >
            <mat-option *ngFor="let type of slmPeriodTypes" [value]="type.value">{{
              type.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">SLM Data TLV Size</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-data width-75 float-left"
            name="slmDataSize"
            #slmDataSizeInput="ngModel"
            [(ngModel)]="formField.slmDataSize"
            min="0"
            max="1476"
            required
          />
          <div
            class="error clr-float"
            *ngIf="slmDataSizeInput.invalid && (slmDataSizeInput.dirty || slmDataSizeInput.touched)"
          >
            <mat-error *ngIf="slmDataSizeInput.errors?.required"> Field is required</mat-error>
            <mat-error *ngIf="slmDataSizeInput.errors?.min || slmDataSizeInput.errors?.max">
              Value should be 0 to 1476</mat-error
            >
          </div>
        </div>
        <div class="group">
          <div class="label">DMM Period</div>
          <mat-select
            class="option-list width-100"
            #dmmPeriodInput="ngModel"
            [(ngModel)]="formField.dmmPeriod"
            name="dmmPeriod"
            required
          >
            <mat-option *ngFor="let item of dmmPeriodTypes" [value]="item.value">{{
              item.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">DMM Data TLV Size</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-data width-75 float-left"
            name="dmmDataSize"
            #dmmDataSizeInput="ngModel"
            [(ngModel)]="formField.dmmDataSize"
            min="0"
            max="1460"
            required
          />
          <div
            class="error clr-float"
            *ngIf="dmmDataSizeInput.invalid && (dmmDataSizeInput.dirty || dmmDataSizeInput.touched)"
          >
            <mat-error *ngIf="dmmDataSizeInput.errors?.required"> Field is required</mat-error>
            <mat-error *ngIf="dmmDataSizeInput.errors?.min || dmmDataSizeInput.errors?.max">
              Value should be 0 to 1460</mat-error
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-data">
        <div class="group">
          <div class="label">CCM Period</div>
          <mat-select
            name="ccmPeriod"
            class="option-list"
            #ccmPeriodInput="ngModel"
            [(ngModel)]="formField.ccmPeriod"
            (selectionChange)="onCCMPeriodChange()"
          >
            <mat-option *ngFor="let type of ccmPeriodTypes" [value]="type.value">{{
              type.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField?.ccmPeriod !== 'off'">
          <div class="label">MEG ID Format</div>
          <mat-select
            name="megIdFormat"
            class="option-list width-200"
            #megIdFormatInput="ngModel"
            [(ngModel)]="formField.megIdFormat"
          >
            <mat-option *ngFor="let type of megIdFormatTypes" [value]="type.value">{{
              type.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField?.ccmPeriod !== 'off'">
          <div class="label">MEG ID</div>
          <input
            matInput
            autocomplete="off"
            type="text"
            class="input-data width-200 float-left"
            name="megId"
            #megIdInput="ngModel"
            [(ngModel)]="formField.megId"
            maxlength="43"
          />
          <div
            class="error clr-float"
            *ngIf="megIdInput.invalid && (megIdInput.dirty || megIdInput.touched)"
          >
            <mat-error *ngIf="megIdInput.errors?.maxlength">
              Maximum of 43 characters allowed.
            </mat-error>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-data">
        <div class="group">
          <div class="label">Standard</div>
          <mat-select
            name="standard"
            class="option-list"
            #standardInput="ngModel"
            [(ngModel)]="formField.standard"
            (selectionChange)="onStandardChange()"
          >
            <mat-option *ngFor="let type of standardTypes" [value]="type.value">{{
              type.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField?.standard !== 'ITU'">
          <div class="label">MD Name Format</div>
          <mat-select
            name="mdNameFormat"
            class="option-list width-200"
            #mdNameFormatInput="ngModel"
            [(ngModel)]="formField.mdNameFormat"
          >
            <mat-option *ngFor="let type of mdNameFormatTypes" [value]="type.value">{{
              type.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField?.standard !== 'ITU'">
          <div class="label">MD Name</div>
          <input
            matInput
            autocomplete="off"
            type="text"
            class="input-data width-200 float-left"
            name="mdName"
            #mdNameInput="ngModel"
            [(ngModel)]="formField.mdName"
            maxlength="43"
          />
          <div
            class="error clr-float"
            *ngIf="mdNameInput.invalid && (mdNameInput.dirty || mdNameInput.touched)"
          >
            <mat-error *ngIf="mdNameInput.errors?.maxlength">
              Maximum of 43 characters allowed.
            </mat-error>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btn-group">
    <button
      mat-flat-button
      class="save-btn"
      [disabled]="!form.valid"
      (click)="savePerformanceMonitorData()"
    >
      SAVE
    </button>
    <button mat-button class="save-btn cancel" mat-dialog-close>CANCEL</button>
  </div>
</form>
